var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPinterestDesktopMore = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 5,
  viewBox: "0 0 19 5",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M16.5 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m-7 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m-7 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"
})));
export default SvgPinterestDesktopMore;